export default function initTrackingForFaqs() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const type = entry.target.getAttribute('data-id');
        const header = entry.target.querySelector('button span').innerText;

        App.track.event('location_page_interaction', {
          section: 'programmatic_faq',
          element: type,
          element_value: header,
          interaction: 'visible',
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5,
  });

  document.querySelectorAll('.faq-section .ds-accordion').forEach(section => {
    section.addEventListener('click', (e) => {
      const type = e.currentTarget.getAttribute('data-id');
      const header = e.currentTarget.querySelector('button span').innerText;

      App.track.event('location_page_interaction', {
        section: 'programmatic_faq',
        element: type,
        element_value: header,
        interaction: 'click',
      });
    });

    observer.observe(section);
  });
}
